<template>
    <tbody>
        <tr>
            <td>{{ item.ContratoPAR }}</td>
            <td align="center">{{ item.Data | date("dd/LL/yyyy") }}</td>
            <td>{{ item.Proprietario }}</td>
            <td>{{ item.SituacaoJuridico }}</td>
            <td align="center">
                <download-link
                    v-if="item.NumeroProcesso != ''"
                    href="https://www.tjrs.jus.br/novo/busca/?tipoConsulta=por_processo&return=proc&client=wp_index&combo_comarca=&comarca=&numero_processo=&numero_processo_desktop=&CNJ=N&comarca=&nome_comarca=&uf_OAB=RS&OAB=&comarca=&nome_comarca=&nome_parte="
                    target="_system" 
                    class="default-button full icon"
                >
                    {{ item.NumeroProcesso }}
                    <i class="mdi mdi-cloud-download-outline"></i>
                </download-link>
                <span v-else>Não Informado</span>
            </td>
            <td>{{ item.Advogado }}</td>
        </tr>
        <tr v-if="item.Registro != ''">
            <td><b>Registro</b></td>
            <td colspan="5" v-nl2br>{{ item.Registro }}</td>
        </tr>
    </tbody>
</template>
<script>
export default {
    props: ["item"],
};
</script>